import { useMemo, useState } from 'react'
import { getUsuarioInfo } from '../../../../../services/localstorage/localstorage.service'
import {
  parseToMysqlFormat,
  parseToMysqlTimeFormat,
} from '../../../../../services/util/date.service'
import { errorHandler } from '../../../../../services/util/error.service'
import * as TransferHttp from '../../../../../services/api/https/deliveries/delivery-transfer.http'

const NOVA_TRANSFERENCIA = {
  transfer_name: '',
  departure_date: null,
  departure_time: '',
  driver_name: '',
  vehicle_plate: '',
  status: 'Aguardando Transferencia',
}
const INITIAL_STATE = {
  transferencia: NOVA_TRANSFERENCIA,
  tpId: null,
  errorMessage: null,
  isLoading: false,
  transferenciaWasSaved: false,
}

export default function useModalTransferencia() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      setTp(tpId) {
        setState(prevState => ({ ...prevState, tpId }))
      },

      setTransferencia(transferencia) {
        setState(prevState => ({
          ...prevState,
          transferencia: transferencia ? transferencia : { ...NOVA_TRANSFERENCIA },
        }))
      },

      async save(transfer, tpId) {
        try {
          if (
            !transfer.transfer_name ||
            !transfer.departure_date ||
            !transfer.departure_time ||
            !transfer.driver_name ||
            !transfer.vehicle_plate
          ) {
            setState(prevState => ({
              ...prevState,
              errorMessage: 'Preencha os campos obrigatórios',
            }))
            return
          }
          setState(prevState => ({ ...prevState, isLoading: true }))
          await TransferHttp.saveDeliveryTransfer(buildTransferencia(transfer, tpId))
          setState(prevState => {
            return {
              ...prevState,
              isLoading: false,
              transferenciaWasSaved: true,
              transferencia: { ...NOVA_TRANSFERENCIA },
            }
          })
        } catch (error) {
          setState(prevState => ({ ...prevState, errorMessage: errorHandler(error) }))
        }
      },

      onFormDataChange(fieldName, value) {
        setState(prevState => {
          prevState.transferencia[fieldName] = value
          return { ...prevState }
        })
      },

      resetMessages() {
        setState(prevState => ({ ...prevState, errorMessage: null }))
      },
    }
  }, [])

  return { state, localDispatch }
}

function buildTransferencia(transfer, tpId) {
  const { id: user_id } = getUsuarioInfo()
  const { transfer_id, transfer_name, departure_date, departure_time, driver_name, vehicle_plate } =
    transfer
  return {
    id: transfer_id,
    name: transfer_name.toUpperCase(),
    departure_date: parseToMysqlFormat(departure_date),
    departure_time: parseToMysqlTimeFormat(departure_time),
    driver_name: driver_name.toUpperCase(),
    vehicle_plate: vehicle_plate.toUpperCase(),
    tp_id_origin: tpId,
    user_id,
  }
}
